import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";





interface DropdownItem {
    label: string;
    link?: string;
    icon?: React.ReactNode | string;
    subDropdown?: DropdownItem[];
    img?: string;
}

interface Menu {
    key: string;
    label: string;
    link?: string;
    icon?: React.ReactNode | string;
    dropdownIcon?: React.ReactNode | string;
    dropdown?: DropdownItem[];
}

interface CustomNavbarProps {
    isMobile: boolean;
    mobileMenuOpen:boolean
}


const menus: Menu[] = [
    {
        key: 'home',
        label: 'HOME',
        link: '/',
        icon: '🏠',
        dropdownIcon: '▼',
        dropdown: [
            { label: 'Specials', link: '/special', icon: '🎉' },
            { label: 'Cart', link: '/cart', icon: '🛒' },
        
            // {
            //     label: 'Account',
            //     icon: '👤',
            //     subDropdown: [
            //         { label: 'Login', link: '/loginSignUp', icon: '🔐' },
            //         { label: 'Check your order', link: '/orderLogin', icon: '📦' }
            //     ]
            // }
        ]
    },
    {
        key: 'cooking', label: 'Cooking Materials', link: '/special', dropdownIcon: '▼',
        dropdown: [
            { label: 'Grains And Rice', link: '/special' },
            { label: 'Pulses', link: '/special' },
            { label: 'Spices & Nuts', link: '/special' },
            { label: 'Flour & Masalas', link: '/special' },
            { label: 'Oil & Condiments', link: '/special' },
            { label: 'Ready for Cook', link: '/special' },
            { label: 'Diary Products', link: '/special' },
            { label: 'Other ingredients', link: '/special' }
        ]
    },
    {
        key: 'shop', label: 'Beverages Mix & Snacks', link: '/special', dropdownIcon: '▼',
        dropdown: [
            { label: 'Tea & Coffee', link: '/special' },
            { label: 'Health Drinks', link: '/special' },
            { label: 'Snacks', link: '/special' },
            { label: 'Biscuits', link: '/special' }
        ]
    },
    {
        key: 'personal', label: 'Personal Care', link: '/special', dropdownIcon: '▼',
        dropdown: [
            { label: 'Oral Care', link: '/special' },
            { label: 'Body Care', link: '/special' },
            { label: 'Hair Care', link: '/special' },
            { label: 'Face Care', link: '/special' },
            { label: 'Baby Care', link: '/special' },
            { label: 'Shaving & Hair Removal', link: '/special' },
            { label: 'Feminine Hygiene', link: '/special' }
        ]
    },
    {
        key: 'household', label: 'Household Care & Cleaning', link: '/special', dropdownIcon: '▼',
        dropdown: [
            { label: 'Laundry Detergents', link: '/special' },
            { label: 'Utensils Cleaner /Dishwash', link: '/special' },
            { label: 'Household Cleaners & Freshner', link: '/special' },
            { label: 'Cleaning Tools', link: '/special' },
            { label: 'Insect Repellents', link: '/special' },
            { label: 'Pooja/Devotional Products', link: '/special' },
            { label: 'Miscellaneous', link: '/special' },
            { label: 'Stationary', link: '/special' }
        ]
    }
];
const CustomNavbar: React.FC<CustomNavbarProps> = ({ isMobile,mobileMenuOpen }) => {
    const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);
    const [hoveredDropdownItem, setHoveredDropdownItem] = useState<number | null>(null);
    const navigate = useNavigate();

    return (
        <>
            {!isMobile && !mobileMenuOpen && (
                <nav style={{
                    backgroundColor: "#F5F5F5",
                    border: "1px solid #d7d8da",
                    boxShadow: "0 10px 33px rgba(0,0,0,0.1)",
                    fontFamily: "Arial, sans-serif",
                    margin: '20px'
                }}>
                    <ul style={{
                        display: "flex",
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                    }}>
                        {menus.map((menu, index) => {
                            const isHovered = hoveredMenu === menu.key;
                                const isHome = menu.key === "home";

                            return (
                                <li
                                    key={menu.key}
                                    style={{
                                        flex: 1,
                                        position: "relative",
                                        textAlign: "left",
                                        borderRight: index === menus.length - 1 ? "none" : "1px solid #ccc",
                                        cursor: "pointer",
                                        padding: "14px 16px",
                                        color: isHovered || isHome  ? "white" : "#555",
                                        backgroundColor: isHovered || isHome ? "#00a1cb" : "#F5F5F5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        gap: 6,
                                        userSelect: "none",
                                        transition: "background-color 0.3s, color 0.3s",
                                    }}
                                    onMouseEnter={() => setHoveredMenu(menu.key)}
                                    onMouseLeave={() => {
                                        setHoveredMenu(null);
                                        setHoveredDropdownItem(null);
                                    }}
                                >
                                    <Link
                                       to={`${menu.link}?category=${encodeURIComponent(menu.label)}`}
                                        style={{
                                            textDecoration: "none",
                                            color: "inherit",
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {menu.icon && <span style={{ marginRight: 6 }}>{menu.icon}</span>}
                                        {menu.label}
                                        {menu.dropdown && (
                                            <span style={{
                                                marginLeft: 6,
                                                fontSize: 12,
                                                color: isHovered ? "white" : "#666",
                                            }}>
                                                {menu.dropdownIcon}
                                            </span>
                                        )}
                                    </Link>

                                    {isHovered && menu.dropdown && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                backgroundColor: "white",
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                zIndex: 999,
                                                width: 260,
                                                display: "block",
                                                padding: "10px",
                                                boxSizing: "border-box"
                                            }}
                                            onMouseEnter={() => setHoveredMenu(menu.key)}
                                            onMouseLeave={() => {
                                                setHoveredMenu(null);
                                                setHoveredDropdownItem(null);
                                            }}
                                        >
                                            <ul style={{
                                                listStyle: "none",
                                                margin: 0,
                                                padding: 0,
                                                overflowY: "auto",
                                                maxHeight: 240,
                                                width: "100%",
                                                textAlign: "left",
                                                paddingLeft: "10px",
                                                boxSizing: "border-box",
                                            }}>
                                                {menu.dropdown.map((item, idx) => {
                                                    const isItemHovered = hoveredDropdownItem === idx;
                                                    return (
                                                        <li
                                                            key={idx}
                                                            style={{
                                                                padding: "8px 12px",
                                                                fontSize: 13,
                                                                borderBottom: "1px solid #f0f0f0",
                                                                color: isItemHovered ? "white" : "#444",
                                                                backgroundColor: isItemHovered ? "#00a1cb" : "transparent",
                                                                cursor: "pointer",
                                                                textAlign: "left",
                                                            }}
                                                            onMouseEnter={() => setHoveredDropdownItem(idx)}
                                                            onMouseLeave={() => setHoveredDropdownItem(null)}
                                                        >
                                                            {item.link ? (
                                                                <Link
                                                                    to={`${item.link}?subLabel=${encodeURIComponent(item.label)}`}
                                                                    style={{
                                                                        textDecoration: "none",
                                                                        color: "inherit",
                                                                        fontWeight: 600,
                                                                        display: "block",
                                                                        width: "100%",
                                                                        textAlign: "left",
                                                                    }}
                                                                >
                                                                    {item.label}
                                                                </Link>
                                                            ) : (
                                                                <span style={{ fontWeight: 600 }}>{item.label}</span>
                                                            )}

                                                            {item.subDropdown && isItemHovered && (
                                                                <ul style={{
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    left: 0,
                                                                    backgroundColor: "white",
                                                                    zIndex: 999,
                                                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                                                    borderRadius: 4,
                                                                    minWidth: 180,
                                                                    padding: "5px 0",
                                                                    textAlign: "left",
                                                                }}>
                                                                    {item.subDropdown.map((subItem, i) => (
                                                                        <li
                                                                            key={i}
                                                                            style={{
                                                                                padding: "6px 12px",
                                                                                textAlign: "left",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={() => {
                                                                                if (subItem.link) {
                                                                                    navigate(subItem.link, { state: { subLabel: subItem.label } });
                                                                                }
                                                                            }}
                                                                        >
                                                                            <span style={{ color: "#444" }}>{subItem.label}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            )}
        </>
    );
};

export default CustomNavbar;

